<template>
  <el-dialog
    title="请拿起二维码扫码枪"
    v-model="showView"
    width="340px"
    :before-close="handleClose"
    :show-close="false"
  >
    <div class="flex flex-row items-center">
      <el-input
          type="password"
          clearable
        autocomplete="off"
        name="inputScanVal"
        v-model="inputScanVal"
        placeholder="扫 实体卡二维码 或 电子卡二维码"
        style="max-width: 300px"
        @keyup.enter="clickScanCard"
        :id="scanFieldID"
      ></el-input>
    </div>
    <template #footer>
      <span class="dialog-footer flex justify-between items-center">
        <el-switch
          v-model="series"
          :disabled="disScanTypeSwitch"
          active-color="#13ce66"
          inactive-text="单扫"
          active-text="连扫"
        ></el-switch>

        <el-button @click="scanCardCloseEvent">取 消</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { scanCard } from '@/utils/member.js'
export default {

  name: 'ScanCard',
  props: {
    fromw: Number,
    showView: Boolean,
    series: Boolean,
    disScanTypeSwitch: Boolean,
    scanFieldID:{
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const inputScanVal = ref('')
    const clickScanCard = () => {
      if (inputScanVal.value.trim() == '') {
        ElMessage({
          showClose: true,
          message: '请先扫描会员卡二维码',
          type: 'error'
        })

        return
      }

      scanCard(inputScanVal.value.trim(), props.fromw, (cardParm) => {
        inputScanVal.value = ''

        if (!props.series) scanCardCloseEvent()

        emit('receiveScanReslut', cardParm)
      }, (res) => {
        inputScanVal.value = ''
      })
    }
    const handleClose = () => {}
    const scanCardCloseEvent = () => {
      inputScanVal.value = ''
      emit('scanCardClose')
    }
    watch(
      () => props.showView,
      (newVal, oldVal) => {
        if (newVal) {
          setTimeout(() => {
            document.getElementsByName('inputScanVal')[0].focus();
            if(props.scanFieldID!=''){
                     document.getElementById(props.scanFieldID).focus();
            }
          }, 100)
        }
      }
    )

    return {
      clickScanCard,
      inputScanVal,
      handleClose,
      scanCardCloseEvent
    }
  }
}
</script>
